// src/components/EventSteps/ArtistsStep.tsx
import React from 'react';
import {
    Box,
    Card,
    FormControl,
    FormLabel,
    Input,
    Typography,
    Button,
    Stack,
    Chip,
} from '@mui/joy';
import { Add, Delete, ChevronRight, ChevronLeft } from '@mui/icons-material';
import { useEventForm } from '../../context/EventFormContext';

interface ArtistStepProps {
    onSubmit: (data: any) => Promise<void>;
}
const ArtistsStep: React.FC<ArtistStepProps> = ({onSubmit}) => {
    const {
        newArtiste,
        setNewArtiste,
        artistes,
        setArtistes,
        setFourthFormData,
        setStep,
        validateStep4
    } = useEventForm();

    const addArtiste = () => {
        const trimmed = newArtiste.trim();
        if (trimmed) {
            const updatedList = [...artistes, trimmed];
            setArtistes(updatedList);
            setFourthFormData(updatedList);
            setNewArtiste('');
        }
    };

    const deleteArtiste = (index: number) => {
        const updatedList = artistes.filter((_, i) => i !== index);
        setArtistes(updatedList);
        setFourthFormData(updatedList);
    };

    return (
        <>
            {/* Navigation */}
            <Stack direction="row" justifyContent="space-between" spacing={2}>
                <Button
                    size="lg"
                    variant="outlined"
                    color="neutral"
                    onClick={() => setStep((prev) => prev - 1)}
                    startDecorator={<ChevronLeft />}
                >
                    Précédent
                </Button>
                <Button
                    color={'success'}
                    size="lg"
                    variant="solid"
                    onClick={async () => {
                        if (await validateStep4()) {
                            await onSubmit('')
                        }
                    }}
                    endDecorator={<ChevronRight />}
                >
                    Valider
                </Button>
            </Stack>

            {/* Section Ajout d'artiste */}
            {/* <Card variant="outlined" sx={{ p: 3, mb: 3 }}>
                <Typography level="h4" mb={2}>
                    Ajouter un artiste
                </Typography>
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={2}
                    alignItems="center"
                    justifyContent="space-between" // Ajoute un espace entre les éléments
                >
                    <FormControl sx={{ flex: 1 }}>
                        <FormLabel>Nom de l'artiste</FormLabel>
                        <Input
                            placeholder="Saisissez un nom..."
                            value={newArtiste}
                            onChange={(e) => setNewArtiste(e.target.value)}
                        />
                    </FormControl>
                    <Button
                        variant="solid"
                        color="primary"
                        onClick={addArtiste}
                        sx={{ minWidth: '120px' }} // Ajustez la largeur minimale du bouton si nécessaire
                    >
                        <Add className='mr-1' />Ajouter
                    </Button>
                </Stack>

            </Card> */}
            <Card variant="outlined" sx={{ p: 3, mt: 2, mb: 2 }}>
    <Typography level="h4" mb={2}>
        Ajouter un artiste
    </Typography>
    <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        alignItems="flex-start" // Aligne les éléments au début de la ligne
    >
        <FormControl sx={{ flex: 1 }}>
            <FormLabel>Nom de l'artiste</FormLabel>
            <Input
                placeholder="Saisissez un nom..."
                value={newArtiste}
                onChange={(e) => setNewArtiste(e.target.value)}
            />
        </FormControl>
        <Button
            variant="solid"
            color="primary"
            onClick={addArtiste}
            sx={{ alignSelf: 'flex-end', minWidth: '120px' }} // Aligne le bouton en bas et définit une largeur minimale
        >
            <Add className='mr-1' />Ajouter
        </Button>
    </Stack>
</Card>


            {/* Liste des artistes */}
            <Card variant="outlined" sx={{ p: 3 }}>
                <Typography level="h4" mb={2}>
                    Artistes sélectionnés
                </Typography>
                {artistes.length === 0 ? (
                    <Typography level="body-md" color="neutral">
                        Aucun artiste sélectionné.
                    </Typography>
                ) : (
                    <Stack direction="row" spacing={1} flexWrap="wrap">
                        {artistes.map((artiste, index) => (
                            <Chip
                                key={index}
                                size="lg"
                                variant="soft"
                                color="neutral"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    deleteArtiste(index);
                                }}
                                endDecorator={
                                    <Button
                                        variant="plain"
                                        color="neutral"
                                        size="lg"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            deleteArtiste(index);
                                        }}
                                    >
                                        <Delete fontSize="small" />
                                    </Button>
                                }
                                sx={{ mb: 1 }}
                            >
                                <span className='!ml-4'>{artiste}</span>
                            </Chip>
                        ))}
                    </Stack>
                )}
            </Card>
        </>
    );
};

export default ArtistsStep;